/* Enable click event for the Programs filter buttons */
exports.setupNewsFilterWidget = function (WidgetuuID, DefaultFilterBy) {
	var filterList = ['Category','Campus','Year','Page']	
	
	// Activate Click event under the filter buttons
	$.each(filterList, function(i,FilterItem){
		$('#Btn' + FilterItem + '_' + WidgetuuID).click(function () {
			window.location.href = setFilterBy({url_string:window.location.href,cFilterBy:FilterItem,iFilterByValue:''});
		});

		$('#Ls' + FilterItem + '_' + WidgetuuID).change(function () {
			window.location.href = setFilterBy({url_string:window.location.href,cFilterBy:FilterItem,iFilterByValue:this.value});
		});
	});
};

function setFilterBy(args){
  var returnURL = '';
  
  if(args.iFilterByValue){
    returnURL = args.url_string.split('?')[0] + '?filterby=' + args.cFilterBy + '&' + args.cFilterBy + '=' + args.iFilterByValue + "#NewsAnchor";
  } else {
    returnURL = args.url_string.split('?')[0] +'?filterby='+ args.cFilterBy + "#NewsAnchor";
  }

  return returnURL;
}